// extracted by mini-css-extract-plugin
export default {"itemCard":"index_itemCard__6nFU1","removeBtn":"index_removeBtn__zoUZ+"};